import React from 'react';
import { SelectElement as SelectType } from '../../types/element.types';

interface SelectElementProps {
  element: SelectType;
}

/**
 * Select/Dropdown Element Renderer
 */
const SelectElement: React.FC<SelectElementProps> = ({ element }) => {
  const { label, options, required, name } = element.settings || { options: [] };

  return (
    <div className="select-element-wrapper">
      {label && (
        <label className="block text-sm font-medium mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        required={required}
        name={name}
        className="select-element"
        style={element.styles as React.CSSProperties}
      >
        <option value="">Select an option</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectElement;

